import { translations as zTranslations } from '@juit/vue-z'

import type { Translations } from '@juit/vue-i18n'

/* ===== TRANSLATIONS ======================================================= */

export const translations = {
  // Generic actions
  'new': { en: 'New', de: 'Neuer' },
  'login': { en: 'Login', de: 'Einloggen' },
  'logout': { en: 'Logout', de: 'Ausloggen' },
  'confirm': { en: 'Confirm', de: 'Bestätigen' },
  'download': { en: 'Download', de: 'Herunterladen' },
  'regenerate': { en: 'Regenerate', de: 'Erneuern' },

  // Generic field names
  'name': { en: 'Name', de: 'Name' },
  'email': { en: 'Email Address', de: 'E-Mail-Adresse' },
  'password': { en: 'Password', de: 'Passwort' },
  'date': { en: 'Date', de: 'Datum' },
  'date.from': { en: 'From', de: 'Von' },
  'date.to': { en: 'To', de: 'Bis' },
  'total': { en: 'Total', de: 'Gesamt' },

  // Users
  'user': { en: 'User', de: 'User' },
  'users': { en: 'Users', de: 'Users' },
  'user.new': { en: 'New User', de: 'Neuer User' },
  'user.edit': { en: 'Edit User', de: 'User Bearbeiten' },
  'user.given_name': { en: 'First name', de: 'Vorname' },
  'user.family_name': { en: 'Last name', de: 'Nachname' },
  'user.employee_number': { en: 'Employee Nr.', de: 'Personalnummer' },

  'user.list.button': { en: 'Upload List', de: 'Liste hochladen' },
  'user.list.title': { en: 'Upload CSV File', de: 'CSV Datei hochladen' },
  'user.list.csv': { en: 'File', de: 'Datei' },
  'user.list.description': { en: 'The file needs to', de: 'Die Datei muss' },
  'user.list.requirements_01': {
    en: 'have a csv extension',
    de: 'ein csv Datei sein',
  },
  'user.list.requirements_02': {
    en: 'have the following structure and headers:',
    de: 'folgende Struktur und Spaltenüberschrift haben:',
  },
  'user.list.requirements_03': {
    en: 'family_name / given_name / email / employee_number',
    de: 'family_name / given_name / email / employee_number',
  },

  // Report
  'report': { en: 'Report', de: 'Bericht' },
  'report.choose': { en: 'Choose report type', de: 'Berichtstyp auswählen' },
  'report.simple': { en: 'Simple report', de: 'Einfacher Bericht' },
  'report.simple.description': { en: 'Total dish consumption per user', de: 'Gesamtverbrauch an Gerichte pro Benutzer' },
  'report.detailed': { en: 'Detailed report', de: 'Ausführlicher Bericht' },
  'report.detailed.description': { en: 'Includes the details of each purchase', de: 'Enthält die Details jedes Kaufs' },
  'dish': { en: 'Dish', de: 'Gericht' },
  'dish.total': { en: 'Number of dishes', de: 'Anzahl der Gerichte' },
  'dish.category': { en: 'Category', de: 'Kategorie' },
  'dish.price.supplement': { en: 'Price supplement', de: 'Preisaufschlag' },
  'dish.price.supplement.total': { en: 'Total price supplement', de: 'Gesamtpreisaufschlag' },

  // More translations
  ...zTranslations,
} as const satisfies Translations
